export default "__VITE_ASSET__7cbf12cb__"